export const colorGroup = {
	// 系统色
	/**
	 * #0052CC
	 */
	primaryColor: '#0052CC', // 主色调
	/**
	 * #0065FF
	 */
	primaryHoverColor: '#0065FF', // 选中颜色
	/**
	 * #2684FF
	 */
	secondBlueColor: '#2684FF', // 用于按钮颜色，不抢眼部分
	/**
	 * #38B17F
	 */
	secondGreenColor: '#38B17F', // icon绿色
	/**
	 * #FF7452
	 */
	secondRedColor: '#FF7452', // icon红色
	/**
	 * #FF9A1F
	 */
	secondYellowColor: '#FF9A1F', // icon黄色

	/**
	 * #F85151
	 */
	tipRed: '#F85151', // 红色

	/**
	 * #0052CC
	 */
	textPrimary: '#0052CC',
	/**
	 * #172B4D
	 */
	textImportant: '#172B4D',
	/**
	 * #344563
	 */
	textInferior: '#344563',
	/**
	 * #6C788C
	 */
	textSlight: '#6C788C', // 三级文字信息
	/**
	 * #A9ADBA
	 */
	textNote: '#A9ADBA', // 用于辅助， 次要的文字信息

	/**
	 * #DFE1E6
	 */
	lineInferior: '#DFE1E6',
	/**
	 * #EBECF0
	 */
	lineSlight: '#EBECF0',

	/**
	 * #F4F5F7
	 */
	bgPage: '#F4F5F7',
	/**
	 * #FAFBFC
	 */
	bgSelect: '#FAFBFC',
	/**
	 * #EBECF0
	 */
	bgBtn: '#EBECF0',

	/**
	 * #053885
	 */
	navColor: '#053885',

	/**
	 * #FFF
	 */
	whiteColor: '#FFF',
};

export const zLevel = {
	top1: 99999, // 系统最高层。 如消息通知， 通知栏信息
	top2: 9999, // 如请求成功，失败
	top3: 1054, //弹窗里的弹窗
	top4: 1001, //比modal高一层级
	top5: 999,
	top6: 99,
	top7: 9, // 临时需要高层
	top8: 1, // 显示高一层
	top9: -1, // 不显示
};
